var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"username","sortable":"custom","label":"Felhasználónév","show-overflow-tooltip":"","width":"150"}})}
var staticRenderFns = []

export { render, staticRenderFns }